// constants.js

export const PAGE_COUNTRY_SCORE_CARD = 'countryScoreCard';
export const PAGE_POLICY_SIMULATOR = 'policySimulator';
export const PAGE_FRAMEWORK = 'framework';
export const PAGE_HOMEPAGE = 'homepage';
export const PAGE_POLICY_IMPLICATIONS = 'policyImplications';
export const PAGE_KEY_INSIGHTS = 'keyInsights';
export const PAGE_NONE = null;


export const AXIS_LABEL_SIZE = window.innerWidth <= 1440 ? window.innerWidth <= 992 ? 11 : 10 : 12
export const AXIS_POINT_SIZE = window.innerWidth <= 1440 ? window.innerWidth <= 992 ? 11 : 10 : 10